import SelectLanguage from './SelectLanguage';

export default SelectLanguage;